import { EMAIL_MESSAGE_STATUSES, PaymentMethods } from '../../../../../../services/exports/Constants';
import TemplateNames from '../email-messages/TemplateNames';

export default {
  page_title: 'Abonați',
  fields: {
    name: 'Nume:',
    email: 'E-mail:',
    phone_number: 'Telefon:',
    subscribed: 'Abonat:',
    birthday: 'Zi de naștere:',
    location: 'Locație:',
    followed: 'Urmărit:',
    lifetime_spent: 'Total cheltuit:',
    total_orders: 'Total comenzi:',
    google_review: 'Recenzie Google:',
    loyalty_lifetime: 'Fidelitate totală:',
    loyalty_points: 'Fidelitate azi:',
  },
  labels: {
    yes: 'Da',
    no: 'Nu',
    followed_since_date: 'Din {{date}}',
  },
  buttons: {
    edit: 'Editează',
    request_data_deletion: 'Solicitați ștergerea datelor',
  },
  toasts: {
    failed_to_load_data: 'Eroare la încărcarea datelor',
  },
  tabs: {
    recent_orders: {
      title: 'Comenzi recente',
      columns: {
        order_id: 'ID',
        items: 'Produse',
        total: 'Sumă totală',
        paid_on: 'Plătit la',
        payment_method: 'Metodă de plată',
      },
      labels: {
        no_orders: 'Nicio comandă încă',
      },
      payment_methods: {
        [PaymentMethods.CARD]: 'Card',
        [PaymentMethods.PAYPAL]: 'PayPal',
        [PaymentMethods.APPLE_PAY]: 'Apple Pay',
        [PaymentMethods.GOOGLE_PAY]: 'Google Pay',
        [PaymentMethods.LINK]: 'Link',
        [PaymentMethods.SOFORT]: 'Sofort',
        [PaymentMethods.IDEAL]: 'iDEAL | Wero',
        [PaymentMethods.BANCONTACT]: 'Bancontact',
        [PaymentMethods.EPS]: 'EPS',
        [PaymentMethods.P24]: 'Przelewy24',
        [PaymentMethods.BLIK]: 'BLIK',
        [PaymentMethods.TWINT]: 'TWINT',
        [PaymentMethods.VENMO]: 'Venmo',
        [PaymentMethods.WERO]: 'Wero',
        [PaymentMethods.KLARNA]: 'Klarna',
        [PaymentMethods.TRUSTLY]: 'Trustly',
        [PaymentMethods.PIX]: 'Pix',
        [PaymentMethods.NUPAY]: 'NuPay',
        [PaymentMethods.GIROPAY]: 'Giropay',
        [PaymentMethods.SEPA_DEBIT]: 'Debit bancar',
        [PaymentMethods.CASH]: 'Numerar',
        [PaymentMethods.BACS_DEBIT]: 'Debit bancar',
      },
    },
    messages: {
      title: 'Mesaje',
      columns: {
        template: 'Șablon',
        status: 'Stare',
        opened: 'Deschis',
        clicked: 'Accesat',
        spam_complaint: 'Reclamație spam',
        unsubscribed: 'Dezabonat',
        sent_at: 'Trimis la',
      },
      labels: {
        yes: 'Da',
        no: 'Nu',
        not_detected: 'Nedetectat',
        opened_at: 'Deschis la {{date}}',
        clicked_at: 'Accesat la {{date}}',
        complained_at: 'Reclamat la {{date}}',
        unsubscribed_at: 'Dezabonat la {{date}}',
        no_messages: 'Niciun mesaj încă',
      },
      message_statuses: {
        [EMAIL_MESSAGE_STATUSES.SENT]: 'Trimis',
        [EMAIL_MESSAGE_STATUSES.DELIVERED]: 'Livrat',
        [EMAIL_MESSAGE_STATUSES.FAILED]: 'Eșuat',
      },
      template_names: {
        ...TemplateNames,
      },
      toasts: {
        failed_to_load_data: 'Eroare la încărcarea datelor',
      },
    },
    balance_history: {
      title: 'Istoric sold',
      columns: {
        created_at: 'Dată',
        source: 'Sursă',
        value: 'Puncte',
        points_expire_at: 'Expiră la',
      },
      labels: {
        source: {
          welcome_bonus: 'Bonus de bun venit',
          google_review_reward: 'Recompensă recenzie Google',
          reward_loyalty_program_conversion: 'Recompensă conversie program fidelitate',
          cashback: 'Cashback',
          refund: 'Rambursare',
          cashback_usage: 'Utilizare cashback',
          cashback_usage_refund: 'Rambursare utilizare cashback',
          expired_points_void: 'Anulare puncte expirate',
          mobile_app_signup_bonus: 'Bonus înregistrare aplicație mobilă',
        },
        no_operations: 'Nicio operațiune încă',
      },
    },
  },
};
